import { useState, useEffect } from 'react';
import { getMicroservices } from '../../../services/b2b-system-apiServices';
import { useLoginContext } from '../../../App';

const useGettingMicroservices = (refreshPeriod = 90000) => {
    const { loginData } = useLoginContext();
    const [microservices, setMicroservices] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let intervalId;

        const fetchMicroservices = async () => {
            setLoading(true);
            try {
                const data = await getMicroservices(loginData.accessToken);
                const instances = data.applications.application.flatMap(app => 
                    app.instance.map(instance => ({
                        ...instance,
                        applicationName: app.name,
                        
                    }))
                );
                setMicroservices(instances);
                setError(null);
            } catch (err) {
                setError(err.message || 'Failed to fetch microservices');
            } finally {
                setLoading(false);
            }
        };

        // Initial fetch
        fetchMicroservices();

        // Set up interval to fetch based on the provided refresh period
        intervalId = setInterval(fetchMicroservices, refreshPeriod);

        // Cleanup interval on component unmount
        return () => clearInterval(intervalId);
    }, [refreshPeriod]);

    return { microservices, error, loading };
};

export default useGettingMicroservices;